import { Component, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import { OpenStreetMapService } from '../../services/open-street-map.service';
@Component({
  selector: 'search-direction',
  templateUrl: './search-direction.component.html',
  styleUrls: ['./search-direction.component.scss']
})
export class SearchDirectionComponent implements AfterViewInit {
  @Input() filter: any = {};
  @Output() onSearch = new EventEmitter<any>();
  constructor(private openStreetMapService: OpenStreetMapService) {
  }
  ngAfterViewInit(): void {
  }
  searchText() {
    this.onSearch.emit(this.filter);
  }
}
